<template>
  <div class="d-flex flex-column">
    <div class="d-flex">
      <v-textarea class="d-flex mr-5" outlined label="Comment" v-model="comment"></v-textarea>
      <v-btn color="primary" @click="addComment" :loading="loading">Send</v-btn>
    </div>

    <div class="d-flex flex-column">
      <template v-if="loading">Loading...</template>
      <v-card v-for="n in data" class="pa-2 mb-5 d-flex align-center">
        <div class="d-flex caption mr-5">
          {{ n.user.email }}
        </div>
        <v-card dark>
          <pre class="black pa-2">{{ n.content }}</pre>
        </v-card>
        <v-spacer></v-spacer>
        <v-btn @click="removeComment(n)" fab color="error">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card>
    </div>
  </div>
</template>

<script>
import { DevsAPI } from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      comment: '',
      data: [],
      loading: false,
    }
  },
  methods: {

    sync() {
      this.loading = true;
      DevsAPI.selectAllComments(this.selected._id).then(res => {
        this.data = res.data
      }).finally(() => this.loading = false)
    },

    addComment() {
      this.loading = true;
      DevsAPI.addComment(this.selected._id, { content: this.comment }).then(res => {
        return this.sync()
      }).finally(() => this.loading = false)
    },

    removeComment(comment) {
      this.loading = true;
      DevsAPI.removeComment(this.selected._id, comment._id).then(() => {
        return this.sync()
      }).finally(() => this.loading = false)
    },
  },
  created() {
    this.sync();
  },
  
  computed: {
    ...mapGetters({
      selected: 'devs/selected',
      mode: 'devs/mode',
      showModal: 'devs/showModal',
    }),
  },
  watch: {
    selected(newValue, oldValue) {
      this.sync();
    }
  }
}
</script>

<style>

</style>